import * as api from '../apis/settings';
import { apiCall } from '~/lib/redux/api';
import { SettingsActions } from './consts';


export function getKYC() {
  return apiCall({
    actions: [
      SettingsActions.LOAD_KYC_REQUEST,
      SettingsActions.LOAD_KYC_SUCCESS,
      SettingsActions.LOAD_KYC_ERROR,
    ],
    fn: () => api.getKYC(),
  });
}

export function updateKYC(req) {
  return apiCall({
    actions: [
      SettingsActions.SAVE_KYC_REQUEST,
      SettingsActions.SAVE_KYC_SUCCESS,
      SettingsActions.SAVE_KYC_ERROR,
    ],
    fn: (state) => {
      const data = state.shared.settings.kyc.data;
      data.legal_name = req.dbaName;
      data.TIN = req.einNumber;

      if (!data.documents)
        data.documents = [];
      data.documents['AOI'] = req.file;

      data.tos_acceptance_date = req.acceptedTerms;
      data.financial_acceptance_date = req.acceptedAgreement;

      return api.setKYC(data);
    },
  });
}
